/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Online_OnlyInputs */



/**
* | output |
* | --- |
* | "Batch export is only available when online." |
*
* @param {Explorer_Info_Batch_Online_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_online_only = /** @type {((inputs?: Explorer_Info_Batch_Online_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Online_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'exportation par lots n'est disponible qu'en ligne.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Stapelexport ist nur im Online-Modus verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'esportazione in batch è disponibile solo quando si è online.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетный экспорт доступен только при подключении к интернету.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La exportación por lotes solo está disponible cuando se está en línea.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量导出功能仅在联网状态下可用。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一括エクスポートは、オンライン時のみ利用可能です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच एक्सपोर्ट की सुविधा केवल ऑनलाइन होने पर ही उपलब्ध है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A exportação em lote só está disponível quando o usuário está online.")
	return /** @type {LocalizedString} */ ("Batch export is only available when online.")
});